








import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Invitation extends Vue {
  @Prop(Number) invitationId!: number
  @Prop(String) hash!: string
  message = '招待を確認中です。'

  mounted() {
    this.acceptInvitation()
  }

  async acceptInvitation() {
    const invitationId = this.invitationId
    const payload = {
      hash: this.hash
    }
    try {
      await this.$api.invitation.acceptPatient({ invitationId, payload })
      this.message = '招待を受諾しました。'
    } catch (error) {
      console.log(error)
      this.message = '招待を確認できませんでした。'
    }
  }
}
